export default __webpack_public_path__ + "static/media/quizzes.3c8e263f.svg";